import { useNavigate, useSearch } from '@tanstack/react-router';

import {
  type AdminUserSortDirection,
  type AdminUserSortProperty,
  type AdminUserStatus,
} from './model';
import {
  parseUsersRouteSearch,
  serializeUsersRouteSearch,
  usersRouteSearchSchema,
} from './usersRouteSearch';

export function useUsersRouteFilters() {
  const navigate = useNavigate({ from: '/admin/users' });
  const search = useSearch({ strict: false });
  const routeSearch = usersRouteSearchSchema(search);
  const filter = parseUsersRouteSearch(routeSearch);
  const update = (next: typeof filter) => {
    void navigate({ search: serializeUsersRouteSearch(next), replace: true });
  };
  return {
    filter,
    setSearch: (searchTerm: string) => {
      update({ ...filter, searchTerm, page: 0 });
    },
    setStatuses: (statuses: AdminUserStatus[]) => {
      update({ ...filter, statuses, page: 0 });
    },
    setRole: (role: string) => {
      update({ ...filter, role, page: 0 });
    },
    setPagination: (page: number, size: number) => {
      update({ ...filter, page, size });
    },
    setSort: (
      sortProperty: AdminUserSortProperty | null,
      sortDirection: AdminUserSortDirection,
    ) => {
      update({ ...filter, sortProperty, sortDirection, page: 0 });
    },
  };
}
